import React from 'react';
import { MuiThemeProvider, Typography } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import createMuiTheme from '@material-ui/core/styles/createMuiTheme';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => {
  return {
    buttonMinimal: {
      padding: theme.spacing(0.5, 2),
      minWidth: 100,
      minHeight: 30,
    },
  };
});

const createCustomColorTheme = (color) => {
  return createMuiTheme(
    {
      palette: {
        secondary: {
          main: color,
        },
      },
      overrides: {
        MuiTypography: {
          subtitle2: {
            fontSize: [ 12, '!important' ],
          },
        },
      },
    },
  );
};

const AppButtonMinimal = (props) => {
  const classes = useStyles();
  const customTheme = createCustomColorTheme(props.color || '#6e920a');

  return (

    <MuiThemeProvider theme={ customTheme }>
      <Tooltip title={ props.tooltip }>
        <span>
          <Button
            className={ clsx(classes.buttonMinimal, props.className) }
            size='small'
            disabled={ props.disabled }
            onClick={ props.onClick }
            color='secondary'
            variant='outlined'
          >
            <Typography variant='subtitle2'>
              {props.text}
            </Typography>
          </Button>
        </span>
      </Tooltip>
    </MuiThemeProvider>
  );
};

export default AppButtonMinimal;
